import { render, staticRenderFns } from "./goal.vue?vue&type=template&id=518014b8&"
import script from "./goal.vue?vue&type=script&lang=js&"
export * from "./goal.vue?vue&type=script&lang=js&"
import style0 from "./goal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports